export default {"src":"/planos/_next/static/media/equifax-thumb-up.29a99d83.svg","height":30,"width":32,"blurWidth":0,"blurHeight":0};